import { NamedEntity } from './misc';
import { LineStyleProps, MonoColorStyle, MonoColorStyleProps, TextStyleProps } from './smpa';
import { UserTickerInfo } from './tickers';

export enum TradingAccountType {
    Virtual = 0,
    BinanceLive = 1,
    BinancePaper = 2
}

export enum TradingOrderType {
    Entry,
    Limit,
    TakeProfit,
    Stop,
    TrailingStop,
    Liquidation
}
export interface TradingAccount extends NamedEntity {
    uId: number;
    apiKey?: string;
    apiSecret?: string;
    type: TradingAccountType;
}
export interface TradingOrder {
    id: number;
    type: TradingOrderType;
    price?: number;
    avgPrice?: number;
    size?: number;
    closePosition: boolean;
    market: boolean;
}
export enum TradingPositionSide {
    Short,
    Long
}
export interface TradingComission {
    taker: number;
    maker: number;
}
export interface TradingPosition {
    accountId: number;
    ticker: UserTickerInfo;
    side: TradingPositionSide;
    lvg: number;
    orders?: TradingOrder[];
    comission?: TradingComission;
    markPrice: number;
    new: boolean;
}
export interface TradingBaseInfo {
    error?: string;
    accountId: number;
    balance: number;
    comission: TradingComission;
    canTrade: boolean;
}
export interface TradingAccountInfo extends TradingBaseInfo {
    positions: TradingPosition[];
}
export interface TradingTickerBraket {
    maxLvg: number;
    minNotionalSize: number;
    maxNotionalSize: number;
    maintRatio: number;
}

export interface TradingTickerInfo extends TradingBaseInfo {
    lvg: number;
    brakets: TradingTickerBraket[];
}

export interface TradingTickData {
    tid: string;
    price: number;
}
export enum TradingInfoDisp {
    r_rr = 1,
    u_rr = 2,
    r_pnl = 4,
    u_pnl = 8,
    s_pnl = 16,
    size = 32,
    sizeUsd = 64
}
export interface TradingToolConfig extends MonoColorStyle, LineStyleProps {

}
export interface OrderConfig extends TradingToolConfig {
    infoDisp: TradingInfoDisp;
}

export interface SelectionConfig extends TradingToolConfig {

}
export interface TradingConfig {
    entry: OrderConfig;
    stop: OrderConfig;
    profit: OrderConfig;
    nentry: OrderConfig;
    nstop: OrderConfig;
    nprofit: OrderConfig;
    selection: SelectionConfig;
}

